<template>
  <div style="background: white;padding:20px;margin-bottom:20px;height:100%;font-size: 14px;">
    <el-row :gutter="20" style="height:100%;margin-bottom: 8px;">
      <el-col :span="18">
        <div>
          <div style="font-size: 16px;">{{cardData.project_name || cardData.clue_desc}}<span class="t-gray" style="font-size:12px;">({{cardData.project_id || cardData.business_id}})</span></div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="t-gray" style="font-size: 12px;text-align: right;">{{cardData.stat_time}}</div>
      </el-col>
    </el-row>

    <el-row :gutter="20" style="height:100%;margin-bottom: 8px;">
      <el-col style="height:100%;margin-bottom: 8px;" :span="22">
        <div style="margin-bottom: 8px;" v-if="cardData.business !== 'clue'">
          <el-tag style="margin-right:6px;" size="mini" :type="cardData.status=='1'?'warning':'success'">{{cardData.project_status}}</el-tag>
          <el-tag style="margin-right:6px;" size="mini" type="info">{{cardData.client_name}}</el-tag>
          <el-tag style="margin-right:6px;" size="mini" type="info">{{cardData.quotation_type}}</el-tag>
        </div>
          <div style="display: flex;align-items:center;">
            <div v-if="status=='1'&&extraData.title" style="margin-right:8px;">⚠️</div>
            <div :class="status=='1' ? 't-red' : 't-gray'">{{extraData.title}}</div>
            <el-divider v-if="extraData.title" direction="vertical"></el-divider>
            <div v-html="formatExtraData" class="t-gray"></div>
          </div>
      </el-col>
      <el-col v-if="status=='1'" :span="2" style="display: flex;justify-content: flex-end;">
        <el-button v-if="cardData.message_type=='31'" size="small" type="primary" @click="handleMessageRquest">去处理</el-button>
        <el-button v-if="cardData.message_type=='4'" size="small" type="primary" @click="setQuotationTime('预计开票时间')">去填写</el-button>
        <el-button v-if="cardData.message_type=='5'" size="small" type="primary" @click="handleMessageAction">去开票</el-button>
        <el-button v-if="cardData.message_type=='6'" size="small" type="primary" @click="setQuotationTime('预计回款时间')">去填写</el-button>
        <el-button v-if="cardData.message_type=='8'" size="small" type="primary" @click="handleMessageAction">完结</el-button>
        <el-button v-if="cardData.message_type=='10' && $store.state.userDept.p_dept_name!=='营销部门'" size="small" type="primary" @click="setQuotationTime('预计交付时间')">去填写</el-button>
        <el-button v-if="cardData.message_type=='11'" size="small" type="primary" @click="handleMessageAction">处理</el-button>
      </el-col>
    </el-row>
    <el-row style="margin:0">
      <div style="background:lightgrey;border-radius: 10px;padding:10px 20px;" v-if="extraData.hasOwnProperty('reason')"><span class="t-gray">修改原因: </span>{{extraData.reason}}</div>
    </el-row>
    <el-divider></el-divider>
    <el-row :gutter="20" v-if="cardData.business !== 'clue'" style="height:100%;margin-bottom: 8px;">
      <el-col :span="24">
        <div style="display: flex;">
          <div style="margin-right:50px;"><span class="t-gray" style="margin-right:10px;">累计报价</span>{{cardData.quotation.toLocaleString()}}</div>
          <div style="margin-right:50px;"><span class="t-gray" style="margin-right:10px;">累计收入</span>{{cardData.income.toLocaleString()}}</div>
          <div style="margin-right:50px;"><span class="t-gray" style="margin-right:10px;">累计开票</span>{{cardData.invoice.toLocaleString()}}</div>
          <div style="margin-right:50px;"><span class="t-gray" style="margin-right:10px;">累计回款</span>{{cardData.collection.toLocaleString()}}</div>
        </div>
      </el-col>
    </el-row>
    <addTimeDialog v-model="showDialog" :title="title" :content-item="contentItem" @updateList="$emit('updateList')"/>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import {getClueTrend, getClueCensus, getClueChartCensus, handleMessage} from "@/api/api";
import addTimeDialog from "@/component/My/dialog/addTimeDialog";
export default {
  name: "PreviewCard",
  props:['cardData','status'],
  components:{
    addTimeDialog
  },
  inject: ['tabChange'],
  data(){
    return {
      loading:false,
      listen:false,
      loadingMap:{},
      showDialog:false,
      title:"",
      contentItem:{
        key:"",
        label:""
      },
      // cardData: {
      //   type:"undo",
      //   title:"OA带宽扩容",
      //   order_id:"03456",
      //   time:"2022-01-01",
      //   order_status:"已验收",
      //   client_name:"交银斯罗德基金",
      //   quotation_type:"数字营销活动工具",
      //   tips:"距离已验收已经过了18天",
      //   tips_detail:"距离预计回款时间还有b天，客户仍未回款，请及时关注结算状态。",
      //   total_quotation:30000,
      //   total_income:20000,
      //   total_bill:15000,
      //   total_back:18000
      // }
    }
  },
  async mounted() {
    // await this.refresh(true)
  },
  computed:{
    formatExtraData(){
      let extra_data = this.cardData.extra_data
      let desc = extra_data.desc
      desc = desc.replace('%project_manager%',`<span class="t-blue" style="font-weight: bold;padding: 0 4px">${extra_data.project_manager}</span>`)
      // console.log('desc',desc)
      return desc
    },
    extraData(){
      return this.cardData.extra_data
    }
  },
  watch: {
    refreshCount() {
      this.refresh()
    },
  },

  methods:{
    handleMessageAction(){
      switch (this.cardData.message_type){
        case '5'://去开票
            // console.log('去开票吧')
            window.open('https://www.jiandaoyun.com/dashboard#/app/5e5322c89daa2f000602931c/form/5ef19943335f8500068ba5e9')
          break
        case '8'://完结
            if (Math.abs((this.cardData.collection - this.cardData.income)) > 0.5 || Math.abs((this.cardData.income - this.cardData.invoice)) > 0.5 || Math.abs((this.cardData.invoice - this.cardData.quotation)) > 0.5 ){
              this.$message.warning(`报价、收入、开票和回款不一致`)
              setTimeout(()=>{
                window.open('https://www.jiandaoyun.com/dashboard#/app/5e5322c89daa2f000602931c/form/6224d82b3c33620007db85dc')
              },2000)
            }else{

              // console.log('完结，四数一致')
              this.handleMessageRquest()
            }
          break
        case '11': // 处理
            // 跳转商机详情页
            this.tabChange('Business')
          break
      }
    },

    async checkDoing(confirmMessage='审批同意吗？',confirmText='同意',cancelText='不同意',closeAsCancel=false){
      let title = "提示"
      return new Promise(resolve => {
        this.$alert('<div style="display: flex;flex-direction: column;justify-content: center;align-items: flex-start;">' +
            `<div style="color:black;">${confirmMessage}</div>`+
            '</div>', title, {
              dangerouslyUseHTMLString: true,
              customClass: 'return-visit-message-box-3',
              showCancelButton: true,
              distinguishCancelAndClose:true,
              confirmButtonText: confirmText,
              cancelButtonText: cancelText,
              callback: action => {
                if (action == 'confirm') {
                  // console.log(confirmText)
                  resolve(1)
                } else if(action == 'cancel') {
                  if(closeAsCancel){
                    // console.log('取消')
                    resolve(0)
                  }else{
                    // console.log(cancelText)
                    resolve(-1)
                  }
                } else {
                  // console.log('取消')
                  resolve(0)

                }
              }
            }
        )
      })


    },

    async handleMessageRquest(){
      let approver_result = ''
      if(this.cardData.message_type=='31'){
        let action = await this.checkDoing('确认同意吗？','同意','不同意',false)
        // console.log('action',action)
        if(!action) return
        approver_result = action == 1 ? '同意':'不同意'
      }
      if(this.cardData.message_type=='8'){
        let action = await this.checkDoing('确认完结吗？','确认','取消',true)
        if(!action) return

      }
      let postData = {
        type:"part",

            id:this.cardData.id,
            initial_id: this.cardData.initial_id,
            business:this.cardData.business,
            message_type:this.cardData.message_type,
            user:this.cardData.approver,
            business_id:this.cardData.business_id,
            stat_time:this.cardData.stat_time,
            approval_result:approver_result

      }
      // console.log('handleMessageRquest',postData)
      let res = await handleMessage(postData)
      if(res.respCode&&res.respCode=='000000'){
        // console.log('handleMessageRquest',res)
        this.$message.success(res.respMsg)
        this.$emit("updateList")
      }else{
        this.$message.error(res.respMsg)
      }
    },

    setQuotationTime(label){
      this.contentItem.key = this.cardData.message_type
      this.contentItem.label = label
      Object.assign(this.contentItem,this.cardData)
      this.showDialog = true
    },

    async getData(){

      let postData = {
      }
      let res = await getClueCensus(postData)
      let resData = res.respData
      Object.assign(this.cardData,resData)
      this.loading = false
      // console.log('getClueCensus',resData,this.cardData)
    },

    async refresh(loading=true){
      this.loading = loading
      await this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.user-name-title{
  font-size:30px;
  font-weight: 800;
}
::v-deep .el-divider--horizontal{
  margin:12px 0;
}
</style>
